import React, { useState, useEffect } from "react";
import { AiFillEdit, AiOutlineClose } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import ReactModal from "react-modal";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from "react-player";
import { AllChurchHooks } from "../../screens/Ministry/hooks/Ministryhooks";
import { readVideosAction } from "../../store/Languages/LanguageAction";
import VideoLibraryModal from "../TWG/VideoLibraryModal";

import {
  saveVideoRequest,
  updateVideoRequest,
  deleteVideoRequest,
} from "../../store/VideoResouce/videoResourcesActions";

import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField";

const Videofield = ({ church }) => {
  const channelObjId = church?._id;
  const dispatch = useDispatch();
  const [videoList, setvideoList] = useState([]);
  const [galleryResetKey, setGalleryResetKey] = useState(Date.now());


  const [videoName, setVideoName] = useState("");
  const [videoURL, setVideoURL] = useState("");
  const [videoDescription, setVideoDescription] = useState("");
  const [thumbnailImage, setThumbnailImage] = useState(null);

  const [editingIndex, setEditingIndex] = useState(null);
  const [previewItem, setPreviewItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { fetchAllChurches } = AllChurchHooks();
  const [showAddVideoModal, setShowAddVideoModal] = useState(false);
  const [allVideos, setAllVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredVideos, setFilteredVideos] = useState([]);

    useEffect(() => {
        const churchId = church?._id;

    if (!churchId) return; // no church ID → skip

    // ✅ Fetch only the specific church
    fetchAllChurches(1, 0, { }, (res) => {

      const churchData = res?.data?.[0]; // since only 1 church is returned

      if (churchData) {

        // ✅ Store all language metas
        setvideoList(churchData.videos);


      } else {
              }
    },churchId);
  }, [church?._id]);
// 🔥 NEW loadVideos — loads videos from church API instead of video API
const loadVideos = () => {
    const churchId = church?._id;
    if (!churchId) return;

    fetchAllChurches(
      1,
      0,
      {},
      (res) => {
        const churchData = res?.data?.[0];
        if (churchData) {
                    setvideoList(churchData.videos || []);
        }
      },
      churchId
    );
  };

// SAVE OR UPDATE
const handleSave = () => {
    if (!videoName) return toast.error("Video name required!");
    if (!videoURL) return toast.error("Video URL required!");

    const payload = {
      channelObjId,
      videoName,
      videoDescription,
      tumbnailGalleryObjId: thumbnailImage || null,
      youtubeurl: videoURL,
    };
      // UPDATE MODE
    if (editingIndex !== null) {
      const id = videoList[editingIndex]._id;

      dispatch(
        updateVideoRequest({ _id: id, ...payload }, (res) => {
          if (res?.type === 1) {
            // toast.success("Video Updated!");
            resetForm();
            loadVideos();   // 🔥 REFRESH LIST
          } else toast.error("Failed to update video");
        })
      );
      return;
    }

    // SAVE NEW
    dispatch(
      saveVideoRequest(payload, (res) => {
        if (res?.type === 1) {
        //   toast.success("Video Saved!");
          resetForm();
          loadVideos();  // 🔥 REFRESH LIST
        } else toast.error("Failed to save video");
      })
    );
  };


  const resetForm = () => {
    setEditingIndex(null);
    setVideoName("");
    setVideoDescription("");
    setVideoURL("");
    setThumbnailImage(null);
    setGalleryResetKey(Date.now());  // 🔥 Forces GalleryPickerField to reset

  };

  // ----------------------------
  // DELETE VIDEO
  // ----------------------------
  const handleDelete = (index) => {
    const id = videoList[index]?._id;

    dispatch(
      deleteVideoRequest({ _id: id, channelObjId }, (res) => {
        if (res?.type === 1) {
        //   toast.success("Video Deleted!");
          loadVideos();   // 🔥 REFRESH LIST
        } else toast.error("Failed to delete");
      })
    );
  };

  useEffect(() => {
    if (!showAddVideoModal) return;

    setIsLoading(true);
    const fetchAllPages = async (page = 1, accumulatedVideos = []) => {
      try {
        dispatch(
          readVideosAction({
            apiPayloadRequest: {
              page,
              limit: 50,
              searchCriteria: {},
            },
            callback: (res) => {
              if (res?.data) {
                const newVideos = [...accumulatedVideos, ...res.data];
                if (res.data.length === 50) {
                  fetchAllPages(page + 1, newVideos);
                } else {
                  setAllVideos(newVideos);
                  setFilteredVideos(newVideos);
                  setIsLoading(false);
                }
              } else {
                setAllVideos(accumulatedVideos);
                setFilteredVideos(accumulatedVideos);
                setIsLoading(false);
              }
            },
          })
        );
      } catch (error) {
                setIsLoading(false);
      }
    };

    fetchAllPages();
  }, [showAddVideoModal]);
  // ----------------------------
  // EDIT VIDEO
  // ----------------------------
  const handleEdit = (item, index) => {
        setEditingIndex(index);
    setVideoName(item.videoName);
    setVideoURL(item.youtubeurl);
    setVideoDescription(item.videoDescription);
    setThumbnailImage(item.gallery._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ----------------------------
  // THUMBNAIL GALLERY PICK
  // ----------------------------
  const handleThumbSelect = (img) => {
            setThumbnailImage(img?.target?.value?.[0]?.id);
  };
    const handleSelectVideo = (video) => {
     setVideoName(video.video_title);
     setVideoDescription(video.video_description);
     setVideoURL(video?.urls?.[0]?.url_link || "");
     setShowAddVideoModal(false);
     toast.success("Video details added");
   };
  return (
    <>
    {
      church?
    <div className="px-4 text-white">
      {/* SAVE BUTTON */}
      <div className="flex justify-end my-3">
        <button
          onClick={handleSave}
          className="text-yellowish border border-yellowish rounded-xl py-2 px-6 text-[12px] font-medium"
        >
          {editingIndex !== null ? "Update Video" : "Save Video"}
        </button>
      </div>

      {/* VIDEO NAME */}
      <div className="flex items-center justify-between mb-2">
            <label className="text-sm text-white">Video Name</label>

            <button
              onClick={() => setShowAddVideoModal(true)}
              className="flex items-center gap-1 text-yellowish text-sm transition-all duration-200 hover:scale-105"
            >
              <span className="text-xl">+</span>
              Clone TWG Video
            </button>
          </div>
      <input
        type="text"
        placeholder="Video Name"
        value={videoName}
        onChange={(e) => setVideoName(e.target.value)}
        className="bg-blackish p-2 w-full text-white text-[14px] rounded-md h-10"
      />

      {/* DESCRIPTION */}
      <div className="mt-2">
        <ReactQuill
          theme="snow"
          value={videoDescription}
          onChange={setVideoDescription}
          className="bg-blackish text-white rounded-md"
          placeholder="Enter Video Description"
        />
      </div>

      {/* THUMBNAIL PICKER */}
      <GalleryPickerField
        key={galleryResetKey}   // 🔥 Important

        label="Thumbnail Image"
        name="thumbnail"
        church={church}
        handleChange={handleThumbSelect}
      />

      {/* VIDEO URL INPUT / UPLOAD */}
      <input
        type="text"
        placeholder="YouTube or Video URL"
        value={videoURL}
        onChange={(e) => setVideoURL(e.target.value)}
        className="bg-blackish p-2 w-full text-white text-[14px] rounded-md h-10 mt-2"
      />


      {/* GRID LIST */}
    {/* GRID LIST */}
{videoList?.length > 0 && (
  <div className="flex flex-wrap gap-8 mt-6">
    {videoList.map((vid, index) => {
      const thumb =
        vid?.gallery?.imageUrl ||
        "https://placehold.co/600x400?text=Video+Thumbnail"; // fallback

      return (
        <div key={vid._id} className="relative group w-[180px]">
          {/* THUMBNAIL COVER */}
          <div
            className="w-[180px] h-[120px] rounded-lg overflow-hidden border border-gray-700 cursor-pointer relative"
            onClick={() => setPreviewItem(vid)}
          >
            <img
              src={thumb}
              alt="thumbnail"
              className="w-full h-full object-cover"
            />

            {/* PLAY ICON */}
            <div className="absolute inset-0 flex items-center justify-center bg-black/40">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-10 h-10 text-white"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M6.271 11.243 10.271 8 6.271 4.757z" />
              </svg>
            </div>
          </div>

          {/* TITLE */}
          <div className="mt-1 text-[12px] text-center w-full line-clamp-1">
            {vid.videoName}
          </div>

          {/* EDIT */}
          <div className="absolute bottom-2 left-2 bg-black/50 p-1 rounded-full cursor-pointer">
            <AiFillEdit
              className="text-white w-4 h-4"
              onClick={() => handleEdit(vid, index)}
            />
          </div>

          {/* DELETE */}
          <div className="absolute top-2 left-2 bg-black/50 p-1 rounded-full cursor-pointer">
            <AiOutlineClose
              className="text-white w-4 h-4"
              onClick={() => handleDelete(index)}
            />
          </div>
        </div>
      );
    })}
  </div>
)}


      {/* PREVIEW MODAL */}
 {/* PREVIEW MODAL */}
<ReactModal
  isOpen={!!previewItem}
  onRequestClose={() => setPreviewItem(null)}
  className="flex justify-center items-center h-full w-full bg-black/90"
>
  <div className="relative p-4">
    <div
      className="absolute top-2 right-2 cursor-pointer"
      onClick={() => setPreviewItem(null)}
    >
      <ImCross className="text-white w-6 h-6" />
    </div>

    <ReactPlayer
      url={previewItem?.youtubeurl}
      controls
      playing
      width="800px"
      height="450px"
    />
  </div>
</ReactModal>
<VideoLibraryModal
        showVideoLibraryModal={showAddVideoModal}
        setShowVideoLibraryModal={setShowAddVideoModal}
        handleVideoSelection={handleSelectVideo}
      />
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
    <p>Add Church/Ministry/Channel First</p>

   </div>
}
    </>
  );
};

export default Videofield;
